import ReactQuill from 'react-quill';

export const quillRef: { current: ReactQuill | null } = {
    current: null,
};
